import { alpha, darken } from "@mui/material/styles";

// Cores semânticas da Central de Alertas, sempre derivadas da paleta do
// tenant (theme.palette.colors) — nunca hex fixo. Os passos por modo foram
// validados para contraste >= 3:1 sobre background.paper; ainda assim chips,
// barras e marcos nunca dependem só da cor (sempre ícone + rótulo + gaps).

export function corSeveridade(theme, severidade) {
	const { colors } = theme.palette;
	const escuro = theme.palette.mode === "dark";
	const mapa = {
		critico: escuro ? colors.red.light : colors.red.medium,
		alto: escuro ? colors.orange.medium : colors.orange.dark,
		medio: escuro ? colors.yellow.medium : darken(colors.yellow.dark, 0.25),
		baixo: escuro ? colors.blue.light : colors.blue.medium,
		informativo: escuro ? colors.gray.medium : colors.gray.darker,
	};
	return mapa[severidade] || (escuro ? colors.gray.medium : colors.gray.darker);
}

export function corTipoEvento(theme, tipo) {
	const { colors } = theme.palette;
	const escuro = theme.palette.mode === "dark";
	const mapa = {
		queda: escuro ? colors.red.light : colors.red.medium,
		recuperacao: escuro ? colors.green.light : colors.green.medium,
		atendimento_aberto: escuro ? colors.blue.light : colors.blue.medium,
		atendimento_fechado: escuro ? colors.purple.medium : colors.purple.dark,
		os_criada: escuro ? colors.orange.medium : colors.orange.dark,
		os_concluida: escuro ? colors.pink.light : colors.pink.medium,
	};
	return mapa[tipo] || (escuro ? colors.gray.medium : colors.gray.darker);
}

export function corCategoriaInteligente(theme, categoria) {
	const { colors } = theme.palette;
	const escuro = theme.palette.mode === "dark";
	const mapa = {
		zona_morta: escuro ? colors.red.light : colors.red.medium,
		os_faltante: escuro ? colors.blue.light : colors.blue.medium,
		falha_recorrente: escuro ? colors.purple.medium : colors.purple.dark,
		sla_em_risco: escuro ? colors.orange.medium : colors.orange.dark,
	};
	return mapa[categoria] || (escuro ? colors.gray.medium : colors.gray.darker);
}

export function corStatusIncidente(theme, status) {
	const { colors } = theme.palette;
	const escuro = theme.palette.mode === "dark";
	const mapa = {
		aberto: escuro ? colors.red.light : colors.red.medium,
		reconhecido: escuro ? colors.yellow.medium : darken(colors.yellow.dark, 0.25),
		em_andamento: escuro ? colors.blue.light : colors.blue.medium,
		resolvido: escuro ? colors.green.light : colors.green.medium,
		fechado: escuro ? colors.gray.medium : colors.gray.darker,
	};
	return mapa[status] || (escuro ? colors.gray.medium : colors.gray.darker);
}

// Estilo base de chip translúcido no padrão dos chips de status do sistema
// (fundo alpha + texto/borda na cor cheia).
export function chipSemantico(theme, cor) {
	return {
		backgroundColor: alpha(cor, theme.palette.mode === "dark" ? 0.16 : 0.1),
		color: cor,
		borderColor: alpha(cor, 0.5),
	};
}
